import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import DatePicker from 'react-datepicker';
import { createFirebaseItem } from './firebase-helpers'

class CreateEvent extends FirebaseComponent {
  constructor() {
		super()

    this.state = {
      title: '',
      startDate: '',
      momentStartDate: null,
      endDate: '',
      momentEndDate: null,
      loading: false
    }

    this.handleValueChange = this.handleValueChange.bind(this)
    this.handleStartDateChange = this.handleStartDateChange.bind(this)
    this.handleEndDateChange = this.handleEndDateChange.bind(this)
    this.loadingSpinner = this.loadingSpinner.bind(this)
    this.createEvent = this.createEvent.bind(this)
  }

  handleValueChange(event) {
    this.setState({[event.target.name]: event.target.value})
  }

  handleStartDateChange(momentStartDate) {
    this.setState({ momentStartDate, startDate: momentStartDate.format() })
  }

  handleEndDateChange(momentEndDate) {
    this.setState({ momentEndDate, endDate: momentEndDate.format() })
  }

  loadingSpinner() {
    if (this.state.loading) return <i className="fa fa-spinner fa-spin" style={{ 'font-size': '24px' }}></i>
  }

  createEvent(event) {
    event.preventDefault()
    this.setState({ loading: true })

    createFirebaseItem('events', {
      account: this.state.uid,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      title: this.state.title
    }).then(() => {
      this.setState({ title: [], endDate: '', momentEndDate: null, startDate: '', momentStartDate: null, loading: false})
    })
  }

  render() {
    return (
      <div>
        <form>
          <div className="form-group">
            <input
              name="title"
              placeholder="Event Title"
              value={this.state.title}
              onChange={this.handleValueChange}
              type="text"
              className="form-control"
              />
            <DatePicker
              name="startDate"
              selected={this.state.momentStartDate}
              onChange={this.handleStartDateChange}
              placeholderText="Start Date"
              className="form-control"
            />
            <DatePicker
              name="endDate"
              selected={this.state.momentEndDate}
              onChange={this.handleEndDateChange}
              placeholderText="End Date"
              className="form-control"
            />
          </div>
          <button
            className="btn btn-primary btn-sm btn-block"
            onClick={this.createEvent}
            type="submit">{this.loadingSpinner()} CREATE EVENT</button>
        </form>
        {this.state.message}
      </div>
    )
  }
}

export default CreateEvent



// WEBPACK FOOTER //
// ./src/CreateEvent.js